import { HStack, Heading, LinkBox, LinkOverlay, VStack } from "@chakra-ui/react"
import { flattenEdges } from "@pathwright/utils"
import UserAvatarStack from "@pathwright/ux/src/components/avatar/UserAvatarStack"
import Link from "@pathwright/ux/src/components/link/Link"
import { HomeMentorGroupMembershipFragment } from "@pathwright/graphql-client/src/generated"
import { useCanViewSimpleNav } from "../../view-permission/useUnifiedHomePermissions"
import PendingReviewCount from "../PendingReviewCount"

function GroupCard({
  groupMembership
}: {
  groupMembership: HomeMentorGroupMembershipFragment
}) {
  const users = flattenEdges(groupMembership.group.memberships)?.map(
    (um) => um.user
  )
  const userCanViewSimpleNav = useCanViewSimpleNav()
  const groupId = groupMembership.group.id
  const toProps = userCanViewSimpleNav
    ? { relativeTo: `?panel=/groups/${groupId}` }
    : { to: `/community/groups/${groupId}/` }

  return (
    <LinkBox
      as={VStack}
      className="group"
      gap={1}
      transform="scale(1.00)"
      transition="transform .2s ease-out"
      _hover={{ transform: "scale(1.04)" }}
    >
      <HStack
        p={2}
        borderRadius="card"
        bg="blackAlpha.400"
        transition="background .2s ease-out"
        _groupHover={{
          bg: "blackAlpha.600"
        }}
      >
        {!!users && (
          <UserAvatarStack
            size="2xs"
            user={groupMembership.user}
            users={users}
            total={groupMembership.group.memberships?.total || 0}
          />
        )}
        <PendingReviewCount item={groupMembership} hideOnHover={false} />
      </HStack>

      <LinkOverlay asChild>
        <Link
          maxW="100px"
          minW="100%"
          whiteSpace="normal"
          variant="plain"
          textDecor="none"
          {...toProps}
        >
          <Heading
            as="h2"
            className="theme-heading theme-heading-bold"
            size="sm"
            color="whiteAlpha.900"
            fontWeight="bold"
            textShadow="0 4px 4px rgba(0, 0, 0, 0.15)"
            lineClamp={2}
            m={0}
            textAlign="center"
            w="100%"
          >
            {groupMembership.group.name}
          </Heading>
        </Link>
      </LinkOverlay>
    </LinkBox>
  )
}

export default GroupCard
